{% block neti_incomplete_order_reminder_customer_tab %}
    <mt-card
        gap="1rem"
        :title="$t('neti-incomplete-order-reminder.customer.detail.totalEntries')"
        positionIdentifier="neti-next-incomplete-order-reminder-customer-tab"
    >
        <template v-slot:header-right>
            <neti-next-incomplete-order-reminder-config-icon pluginName="NetiNextIncompleteOrderReminder"/>
        </template>

        <neti-ior-cart-listing
            v-if="cartEntries.length > 0"
            :items="cartEntries"
            :repository="repository"
            :columns="columns"
            :showSelection="false"
            :isLoading="isLoading"
            :full-page="false"
            @column-sort="onColumnSort"
            @page-change="onPageChange"
            @update-records="onUpdateRecords"
        >
            <template #column-totalPrice="{ item }">
                <a @click="showCartModal(item)">
                    {{ item.totalPrice }} {{ item.symbol }}
                </a>
            </template>

            <template #column-mailed="{ item }">
                <mt-icon
                    v-if="item.mailed"
                    name="regular-checkmark-xs"
                    size="16px"
                    class="is--active"
                />

                <mt-icon
                    v-else
                    name="regular-times-s"
                    size="16px"
                    class="is--inactive"
                />
            </template>

            <template #column-createdAt="{ item }">
                {{ dateFilter(item.createdAt, {hour: '2-digit', minute: '2-digit', second: '2-digit'}) }}
            </template>

            <template #actions="{ item }">
                <sw-context-menu-item @click="showCartModal(item)">
                    {{ $t('neti-incomplete-order-reminder.customer.contextMenuDetail') }}
                </sw-context-menu-item>
            </template>

            <template #action-modals="{ item }">
                <sw-modal
                    v-if="cartModalOpen === item.token"
                    @modal-close="onCloseCartModal"
                    :title="$t('neti-incomplete-order-reminder.customer.modal.modalTitleDetail')"
                    class="neti--incompleteorderreminder--cart-details-modal"
                >
                    <template
                        v-if="detailCart"
                        class="sw-order-detail-general__line-item-grid-card"
                    >
                        <sw-data-grid
                            class="sw-order-line-items-grid__data-grid"
                            :data-source="detailCart.lineItems"
                            :columns="cartItemColumns"
                            :showSelection="false"
                            :allowDelete="false"
                            :is-loading="isLoading"
                            :showActions="false"
                        >
                            <template
                                #column-label="{ item, isInlineEdit }"
                            >
                                <div
                                    class="sw-order-line-items-grid__item-product"
                                >
                                    <router-link
                                        v-if="item.payload && item.payload.options"
                                        class="sw-order-line-items-grid__item-payload-options"
                                        :title="$t('sw-order.detailBase.contextMenuShowProduct')"
                                        :to="{ name: 'sw.product.detail', params: { id: item.referencedId } }"
                                    >
                                        <sw-product-variant-info
                                            :variations="item.payload.options"
                                        >
                                            <div
                                                class="sw-order-line-items-grid__item-label"
                                            >
                                                {{ item.label }}
                                            </div>
                                        </sw-product-variant-info>
                                    </router-link>

                                    <template
                                        v-else
                                        class="sw-order-line-items-grid__item-payload-options"
                                    >
                                        <span
                                            class="sw-order-line-items-grid__item-label"
                                        >
                                            {{ item.label }}
                                        </span>
                                    </template>
                                </div>
                            </template>

                            <template #column-quantity="{ item }">
                                <span>
                                    {{ item.quantity }} x
                                </span>
                            </template>

                            <template
                                #column-price.unitPrice="{ item }"
                            >
                                <span>
                                    {{ currencyFilter(item.price.unitPrice,  currency.isoCode) }}
                                </span>
                            </template>

                            <template
                                #column-price.totalPrice="{ item }"
                            >
                                <span>
                                    {{ currencyFilter(item.price.totalPrice,  currency.isoCode) }}
                                </span>
                            </template>
                        </sw-data-grid>

                        <sw-card-section
                            divider="top"
                            slim
                        >
                            <sw-description-list
                                class="sw-order-detail__summary"
                                grid="1fr 1fr"
                            >
                                <template>
                                    <dt>
                                        {{ $t('sw-order.detailBase.summaryLabelAmount') }}
                                    </dt>
                                    <dd>
                                        {{ currencyFilter(detailCart.price.positionPrice,  currency.isoCode) }}
                                    </dd>
                                </template>

                                <template>
                                    <dt>
                                        <strong>
                                            {{ $t('sw-order.detailBase.summaryLabelAmountWithoutTaxes') }}
                                        </strong>
                                    </dt>

                                    <dd>
                                        <strong>
                                            {{ currencyFilter(detailCart.price.netPrice,  currency.isoCode) }}
                                        </strong>
                                    </dd>
                                </template>

                                <template>
                                    <dt>
                                        <strong>
                                            {{ $t('sw-order.detailBase.summaryLabelAmountTotal') }}
                                        </strong>
                                    </dt>

                                    <dd>
                                        <strong>
                                            {{ currencyFilter(detailCart.price.totalPrice,  currency.isoCode) }}
                                        </strong>
                                    </dd>
                                </template>
                            </sw-description-list>
                        </sw-card-section>
                    </template>

                    <mt-banner
                        v-else
                        variant="info"
                    >
                        {{ $t('neti-incomplete-order-reminder.customer.modal.loadingCartError') }}
                    </mt-banner>

                    <template #modal-footer>
                        <mt-button
                            variant="secondary"
                            @click="onCloseCartModal"
                            size="small"
                        >
                            {{ $t('neti-incomplete-order-reminder.customer.modal.buttonClose') }}
                        </mt-button>
                    </template>
                </sw-modal>
            </template>

            <template #pagination>
                <sw-pagination
                    :page="page"
                    :limit="limit"
                    :total="total"
                    :total-visible="7"
                    @page-change="onPageChange"
                ></sw-pagination>
            </template>
        </neti-ior-cart-listing>

        <mt-banner
            v-else
            variant="info"
            appearance="notification"
            :showIcon="true"
            :closable="false"
        >
            {{ $t('neti-incomplete-order-reminder.customer.detail.messageEmpty') }}
        </mt-banner>

        <template v-slot:footer>
            <div class="sw-card__footer-slot">
                <neti-next-incomplete-order-reminder-powered-by
                    pluginName="NetiNextIncompleteOrderReminder"
                />
            </div>
        </template>
    </mt-card>
{% endblock %}